import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'react-bootstrap'
import { FaNewspaper } from 'react-icons/fa'

function JornalCTA() {
  return (
    <Container>
      <Row className="align-items-center">
        {/* ── Texto ── */}
        <Col xs={12} md={7} className="jornal-cta-text">
          <p className="jornal-cta-eyebrow">Publicação oficial do sindicato</p>
          <h2 className="jornal-cta-title">Jornal</h2>
          <div className="jornal-cta-divider" />
          <p className="jornal-cta-subtitle">
            Confira todas as edições do Jornal do Sindicato dos
            Metalúrgicos de Bauru e Região.
          </p>
          <Link to="/jornal" className="jornal-cta-btn">
            Últimas edições
          </Link>
        </Col>

        {/* ── Capas decorativas ── */}
        <Col xs={12} md={5} className="d-none d-md-flex justify-content-center align-items-end">
          <div className="jornal-cta-covers" aria-hidden="true">
            <div className="jornal-cta-cover jornal-cta-cover-3">
              <FaNewspaper />
            </div>
            <div className="jornal-cta-cover jornal-cta-cover-2">
              <FaNewspaper />
            </div>
            <div className="jornal-cta-cover jornal-cta-cover-1">
              <FaNewspaper />
            </div>
          </div>
        </Col>

      </Row>
    </Container>
  )
}

export default JornalCTA
